/*
 * @Author: LZT
 * @Date: 2025-04-09 13:53:13
 * @LastEditors: LZT
 * @Description: 自定义指令
 */
import { hideStockName, hideStockCode } from "./index.js";
/**
 * * @description: 隐藏股票名称和代码
 */
const hideStockDirective = {
  mounted(el, binding) {
    if (el.textContent.trim() === "") {
      return;
    }
    el.text = el.textContent;
    // 获取权限参数，支持多种方式传递
    let auth = true;
    if (binding.value !== undefined) {
      // 方式1: v-hideStock="true" 或 v-hideStock="false"
      auth = !binding.value;
    } else if (binding.arg === 'show') {
      // 方式2: v-hideStock:show
      auth = true;
    } else if (binding.arg === 'hide') {
      // 方式3: v-hideStock:hide
      auth = false;
    };

    let text = "";
    // 如果是code   使用方法 v-hideStock.code false是隐藏 true是不隐藏
    if (binding.modifiers.code) {
      // text = hideStockCode(el.textContent, auth);
      text = auth ? el.text : "******";
    } else {
      // text = hideStockName(el.textContent, auth);
      text = auth ? el.text : "****";
    };
    el.textContent = text;
  },
  updated(el, binding) {
    let text = "";
    if (el.textContent.trim() === "") {
      return;
    };
    // 获取权限参数，支持多种方式传递
    let auth = true;
    if (binding.value !== undefined) {
      auth = !binding.value;
    } else if (binding.arg === 'show') {
      auth = true;
    } else if (binding.arg === 'hide') {
      auth = false;
    };

    // 如果是code   使用方法 v-hideStock.code
    if (binding.modifiers.code) {
      // text = hideStockCode(el.textContent, auth);
      text = auth ? el.text : "******";
    } else {
      // text = hideStockName(el.textContent, auth);
      text = auth ? el.text : "****";
    }
    el.textContent = text;
  }
};

// 所有自定义指令
const directives = {
  hideStock: hideStockDirective
};

export default {
  install(app) {
    Object.keys(directives).forEach(key => {
      app.directive(key, directives[key]);
    });
  }
};
